
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-40 overflow-hidden bg-gradient-to-br from-gray-900 to-gray-800">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(16,185,129,0.15),transparent_50%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_60%,rgba(249,115,22,0.12),transparent_50%)]"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-5xl sm:text-6xl lg:text-7xl font-display font-black text-white mb-8 leading-tight">
          {t('cta.title1')}
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
            {t('cta.title2')}
          </span>
        </h2>
        <p className="text-2xl text-white/90 mb-14 max-w-2xl mx-auto font-semibold">
          {t('cta.subtitle')}
        </p>
        <Link
          to="/generator"
          className="inline-flex items-center gap-4 px-12 py-6 bg-primary text-white rounded-full font-black text-xl hover:bg-primary-600 transition-all hover:shadow-2xl hover:shadow-primary/50 group cursor-pointer whitespace-nowrap"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-line text-3xl group-hover:translate-x-2 transition-transform"></i>
        </Link>
        <p className="mt-8 text-white/70 text-base font-bold">
          {t('cta.note')}
        </p>
      </div>
    </section>
  );
}
